module.exports = __webpack_public_path__ + "img/em3.36423ef7.png";